<template>
  <v-footer 
    inset
    :dark="$vuetify.breakpoint.mobile"
  >
    <v-container 
      fluid
      class="pb-0"
    >
      <v-row 
        align="center" 
        no-gutters
        class="mt-5"
      >
        <v-col 
          cols="12"
          class="mx-auto text-center"
        >
          <p class="text-subtitle-1 text-uppercase">
            {{ sysName ? sysName : config.sysTitle }} {{config.provinceName}} © {{(new Date()).getFullYear()}} 
          </p>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-btn text small>
            <span class="primary--text px-1 font-weight-bold">
              {{ (v_online > 0 ? v_online : 1) | currency }}
            </span> 
            đang truy cập
          </v-btn>
          <v-btn text small>
            <span class="primary--text px-1 font-weight-bold">
              {{ (v_today > 0 ? v_today : 1) | currency }}
            </span> 
            hôm nay
          </v-btn>
          <v-btn text small>
            <span class="primary--text px-1 font-weight-bold">
              {{ (v_total > 0 ? v_total : 1) | currency }}
            </span> 
            tổng lượt truy cập
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>
<script>
  import { mapState, mapActions } from 'vuex';
  export default {
    name: 'Footer',
    props: {
      sysName: {
        type: String,
        default: ''
      },
    },
    data: () => ({
      v_online: 1,
      v_today: 1,
      v_total: 1
    }),
    computed: {
      ...mapState([
        'config'
      ])
    },
    mounted () {
      this.getCountVisit();
    },
    methods: {
      ...mapActions([
        'getSystem'
      ]),
      getCountVisit(){
        axios.get("api/v1/public/get-count-visit")
          .then(response => {
            let data = response.data;
            const v_online_obj = data.find(element => element.key === 'ONLINE');
            const v_today_obj = data.find(element => element.key === 'TODAY');
            const v_total_obj = data.find(element => element.key === 'TOTAL');

            this.v_online= v_online_obj ? v_online_obj["value"] : this.v_online;
            this.v_today = v_today_obj ? v_today_obj["value"] : this.v_today;
            this.v_total = v_total_obj ? v_total_obj["value"] : this.v_total;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
    }
  }
</script>